/**
 * @module common/config/mask-configs
 */

/**
 * @hideconstructor
 * @classdesc Конфигурация масок
 */
class MaskConfigs {
  /**
   * @readonly
   * @description Конфигурация маски для телефона
   */
  static get phoneNumber() {
    return {
      mask: '+7 (K00) 000-00-00',
      definitions: {
        K: /[^+78\D]/,
      },
    };
  }
}

export default MaskConfigs;